import { OperationValidationTableComponent } from './operation-validation-table/operation-validation-table.component';
import { OperationValidationComponent } from './../operation-validation/operation-validation.component';
import { GeneralOfInvestmentTableComponent } from './general-of-investment-table/general-of-investment-table.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InvestFormComponent } from './invest-form/invest-form.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MaterialModule } from '@app/material.module';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '@app/@shared';
import { InvestDetailTableComponent } from './invest-detail-table/invest-detail-table.component';
import { CommonFormComponent } from './common-form/common-form.component';
import { RequestsWithDetalilTableComponent } from './requests-with-detail-table/requests-with-detalil-table.component';
import { AgentStatisticTableComponent } from './agent-statistic-table/agent-statistic-table.component';
import { PenaltyDetailTableComponent } from './penalty-detail-table/penalty-detail-table.component';

@NgModule({
  declarations: [
    InvestFormComponent,
    InvestDetailTableComponent,
    PenaltyDetailTableComponent,
    CommonFormComponent,
    RequestsWithDetalilTableComponent,
    AgentStatisticTableComponent,
    GeneralOfInvestmentTableComponent,
    OperationValidationTableComponent,
  ],
  imports: [
    FlexLayoutModule,
    MaterialModule,
    CommonModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
  ],
  exports: [
    InvestFormComponent,
    PenaltyDetailTableComponent,
    InvestDetailTableComponent,
    CommonFormComponent,
    RequestsWithDetalilTableComponent,
    AgentStatisticTableComponent,
    GeneralOfInvestmentTableComponent,
    OperationValidationTableComponent,
  ],
})
export class ControlPanelSharedModule {}
